export function weatherWidget() {
    $(document).on('mouseover', '.weather_container', () => {
        $('.weatherhover').show('slow');
    })

    $(document).on('mouseleave', '.weatherhover', function() {
        $(this).hide('slow');
    })
}